module.exports = __webpack_public_path__ + "h5/img/huangka_bg.b28b01c6.png";